import { Pipe, PipeTransform } from '@angular/core';
import { Trip } from '../../classes/trip';
import dayjs from 'dayjs';
@Pipe({
  name: 'durationTransformer',
  standalone: true,
})
export class DurationTransformerPipe implements PipeTransform {
  private readonly dateFormat = 'ddd, MMM D';

  transform(
    data: Pick<
      Trip,
      'isSpecifyDates' | 'numDays' | 'tripStartDate' | 'tripEndDate'
    >,
  ): string {
    if (!data.isSpecifyDates && data.numDays) {
      return `Trip Duration: ${data.numDays} days`;
    } else if (data.isSpecifyDates && data.tripStartDate && data.tripEndDate) {
      return `${dayjs(data.tripStartDate).format(this.dateFormat)} - ${dayjs(data.tripEndDate).format(this.dateFormat)}`;
    }

    return 'Dates / Duration';
  }
}
